<script lang="ts">
    import Donut from "./Donut.svelte";

    export let donuts: {
        from: number;
        to: number;
        n: number;
    }[] = [{ from: 0, to: 0, n: 0 }];

    function onRemove(i: number) {
        donuts.splice(i, 1);

        donuts = donuts;
    }
</script>

<ul class="list-group mx-2">
    {#if typeof donuts !== "undefined"}
        {#each donuts as donut, i}
            <Donut bind:donut on:remove={() => onRemove(i)}/>
        {/each}
    {/if}
</ul>
